<script lang="ts">
  import { getStr, globalCurrencyTag } from '../../../../common/util';
  import Icon from '../../../common/components/Icon.svelte';
  import Text from '../../../common/components/Text.svelte';
  import ExtraButton from '../../../common/components/ExtraButton.svelte';
  import PictureTag from '../../../common/lazy-components/PictureTag.svelte';

  export let mpOfferData;
  export let productName = '';
  export let productImageUrl = '';
  export let earliestDeliveryDays;
  export let latestDeliveryDays;
  export let onAddToCart: (offerId?: any, quantity?: any) => void = () => {};
</script>

<div class="product-seller-info">
  <div class="current-offer-card">
    <div class="product-image-section">
      <PictureTag image={productImageUrl} getAllResolutions={false} />
    </div>
    <div class="product-details">
      <div class="product-details-section">
        <div class="currently-viewing-label">
          <Text key="extra.marketplace.pdp.seller.currently.viewing.text" />
        </div>
        <div class="condition-label">
          <Text key="extra.marketplace.pdp.seller.condition.text" />:
          <span class="condition-value">{mpOfferData?.state}</span>
        </div>
        <div class="product-name">
          <span class="shop-name">{mpOfferData?.shopName}</span> .
          <span>{productName}</span>
        </div>
      </div>
      <div class="price-action-section">
        <div class="price-amount">
          {@html getStr('jood.price.with.currency', [
            globalCurrencyTag,
            mpOfferData?.discountPrice?.value || mpOfferData?.price?.value,
          ])}
        </div>
        <ExtraButton color="primary" size="small" variant="solid" on:click={() => onAddToCart(mpOfferData?.id, null)}>
          <Text key="extra.addtocartbutton" />
        </ExtraButton>
      </div>
    </div>
  </div>

  <div class="separator-horizontal hide-on-desktop"></div>
  <div class="seller-meta-info">
    <div class="meta-row">
      <div class="meta-item">
        <Icon glyph="icon-box" type="primary" mobileSize={16} desktopSize={16} />
        <span>
          <Text key="extra.marketplace.pdp.seller.sold.by.text" />
          <strong class="shop-name">{mpOfferData?.shopName}</strong>
        </span>
      </div>
      <div class="separator-vertical"></div>
      <div class="meta-item">
        <Icon glyph="icon-standard_delivery" type="primary" mobileSize={16} desktopSize={16} />
        <span>
          {#if earliestDeliveryDays && latestDeliveryDays}
            <Text
              key="extra.marketplace.product.deliveryleadtime.label"
              args={[earliestDeliveryDays, latestDeliveryDays]}
            />
          {:else}
            <Text key="extra.marketplace.product.delivery.withoutdays" />
          {/if}
        </span>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .product-seller-info {
    display: flex;
    flex-direction: column;
    gap: 20px;
    background-color: $neutral-light-04;
    border: 1px solid $primary-blue;
    border-radius: 12px;
    padding: 20px 16px;
    @include desktop-max-width {
      padding: 16px;
    }

    .current-offer-card {
      display: flex;
      gap: 10px;
      padding: 16px 16px 0;
      @include desktop-max-width {
        padding: 0px;
      }
      .product-image-section {
        max-width: 67px;
        height: 100%;
        background: $primary-white;
        border-radius: 5px;
        border: 1px solid $secondary-gray-02;
        padding: 12px 8px;

        .product-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .product-details {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        .product-details-section {
          display: flex;
          flex-direction: column;
          gap: 2px;
          font-size: 12px;
          line-height: 14px;
          font-weight: 500;
          .currently-viewing-label {
            color: $secondary-gray-01;
          }
          .condition-label {
            color: $secondary-gray-01;
            .condition-value {
              color: $icon-only-icon-blue;
              font-weight: 700;
            }
          }
          .product-name {
            color: $neutral-dark-01;
            .shop-name {
              color: $tertiary-blue-03;
            }
          }
        }

        .price-action-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          .price-amount {
            font-size: 16px;
            line-height: 14px;
            font-weight: 700;
            color: $neutral-dark-01;
          }

          :global(.extra-btn button) {
            width: fit-content;
            padding: 8px;
            font-size: 11px;
            line-height: 13px;
            font-weight: 700;
            white-space: nowrap;
          }
        }
      }
    }

    .separator-horizontal {
      width: 298px;
      height: 1px;
      background-color: $secondary-gray-02;
      margin-top: 12px;
      @include desktop-max-width {
        margin-top: 0px;
      }
    }

    .separator-vertical {
      width: 1px;
      height: 25px;
      background-color: $secondary-gray-02;
      flex-shrink: 0;
      border-radius: 1px;
      display: block;
    }

    .seller-meta-info {
      .meta-row {
        display: flex;
        justify-content: center;
        gap: 16px;
        .meta-item {
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          gap: 8px;
          border-radius: 8px;
          font-size: 12px;
          line-height: 14px;
          font-weight: 400;
          @include desktop-max-width {
            gap: 4px;
          }
          svg,
          .icon {
            min-width: 16px;
            min-height: 16px;
            color: $primary-blue;
          }
          span {
            font-size: 12px;
          }
          .shop-name {
            color: $tertiary-blue-03;
          }
        }
      }
    }
  }
</style>
